import React, { Component } from 'react';
import { connect } from 'react-redux';
import PLACE_ICON from 'assets/img/pin_blue.svg';
import FIBER_ICON from 'assets/img/fiber.svg';
import TRUCK_ICON from 'assets/img/truck.svg';
import SPEED_ICON from 'assets/img/speed.svg';
import GLOBE_ICON from 'assets/img/globe.svg';
import CUBE_ICON from 'assets/img/cube.svg';
import BARCODE_ICON from 'assets/img/barcode.svg';
import CIRCLE_ICON from 'assets/img/circle.svg';
import BROADBAND_ICON from 'assets/img/broadband.svg';
import FIBER_ICON_DARK from 'assets/img/black/fiber.svg';
import TRUCK_ICON_DARK from 'assets/img/black/truck.svg';
import SPEED_ICON_DARK from 'assets/img/black/speed.svg';
import GLOBE_ICON_DARK from 'assets/img/black/globe.svg';
import CUBE_ICON_DARK from 'assets/img/black/cube.svg';
import BARCODE_ICON_DARK from 'assets/img/black/barcode.svg';
import CIRCLE_ICON_DARK from 'assets/img/black/circle.svg';
import BROADBAND_ICON_DARK from 'assets/img/black/broadband.svg';
import OVERRIDE from 'assets/img/ok.svg';
import { Progress } from 'antd';
import { AprroveCustomizeIcons, Map, RoundChart } from 'view/common';
import CUSTOMIZE from 'assets/img/black/wrench.svg';
import './style.scss';
import './style_dark.scss';

const ImageWithText = ({ src, text, style = {} }) => (
  <div className="address_card_tag">
    <img src={src} alt="icon" style={{ height: '18px', width: '18px' }} />
    <p style={style}>{text}</p>
  </div>
);

const AsideStatistic = ({ title, percent, children }) => (
  <div className="address_card_statistic" style={{ width: '100%' }}>
    <h3>{title}</h3>
    <div className="address_card_statistic_header">
      <p>Confidence</p>
      <p>{percent === 0 ? '--' : percent} %</p>
    </div>
    <Progress percent={percent} format={() => { }} />
    {children}
  </div>
);

class AddressCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      solution: '',
    };
  }

  dragStartHandler = (e, solution) => {
    this.setState({ solution });
  };

  dragOverHandler = (e) => {
    if (!e.currentTarget.classList.contains('dragOver')) {
      e.currentTarget.classList.add('dragOver');
    }
  };

  dragLeaveHandler = (e) => {
    e.currentTarget.classList.remove('dragOver');
  };

  dropHandler = (e, selection) => {
    this.props.dispatch({
      type: 'TOAST',
      payload: {
        text: `${this.state.solution} solution was added to ${selection} selection`,
      },
    });
    e.currentTarget.classList.remove('dragOver');
  };


  render() {
    const { address = '123 C St. Corona, 92883, CA', activeAddress, isDarkTheme } = this.props;
    if (!activeAddress) return <div />;
    return (
      <div className="modalContent">
        <div className="address_card">
          <div className="address_card_wrapper">
            <Map
              style={{
                width: '100%',
                height: '390px',
              }}
              markerPosition={{ lat: -34.397, lng: 150.644 }}
              isOverriden={activeAddress.isOverriden}
            />
            <div className="address_card_header">
              <div className="address_card_header_text">
                <img src={activeAddress.isOverriden ? OVERRIDE : PLACE_ICON} alt="place" />
                <h2>{address}</h2>
              </div>
            </div>
            <div className="address_card_icons_row">
              <AprroveCustomizeIcons isOverride isCustomize />
            </div>
            <div className="address_card_content">
              <div className="address_card_content_main">
                <div
                  onDragOver={this.dragOverHandler}
                  onDragLeave={this.dragLeaveHandler}
                  onDrop={e => this.dropHandler(e, 'first')}
                  className="address_card_cell"
                >
                  <div className="address_card_row">
                    <RoundChart
                      color="blue"
                      percent={35}
                      width="120px"
                      height="120px"
                      title="Confidence"
                      titleStyle={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: 1.1,
                      }}
                      percentStyle={{
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: 1.1,
                      }}
                      titleBottom
                    />
                    <div className="address_card_statistic" style={{ marginLeft: '5%' }}>
                      <div className="address_card_statistic_title">
                        <p>1st selection:</p>
                        <p>AT&T</p>
                      </div>
                      <div className="address_card_tag_row">
                        <ImageWithText src={isDarkTheme ? FIBER_ICON_DARK : FIBER_ICON} text="Fiber" />
                        <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
                      </div>
                      <div className="address_card_tag_row">
                        <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
                        <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
                      </div>
                    </div>
                    <img
                      src={CUSTOMIZE}
                      style={{
                        marginBottom: 'auto', height: '14px', width: '14px', marginTop: '21px',
                      }}
                      alt="customize icon"
                    />
                  </div>
                </div>
                <div
                  onDragOver={this.dragOverHandler}
                  onDragLeave={this.dragLeaveHandler}
                  onDrop={e => this.dropHandler(e, 'second')}
                  className="address_card_cell"
                >
                  <div className="address_card_row">
                    <RoundChart
                      color="blue"
                      percent={35}
                      width="120px"
                      height="120px"
                      title="Confidence"
                      titleStyle={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: 1.1,
                      }}
                      percentStyle={{
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: 1.1,
                      }}
                      titleBottom
                    />
                    <div className="address_card_statistic" style={{ marginLeft: '5%' }}>
                      <div className="address_card_statistic_title">
                        <p>2nd selection:</p>
                        <p>Verizon</p>
                      </div>
                      <div className="address_card_tag_row">
                        <ImageWithText src={isDarkTheme ? BROADBAND_ICON_DARK : BROADBAND_ICON} text="Broadband" />
                        <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
                      </div>
                      <div className="address_card_tag_row">
                        <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
                        <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
                      </div>
                    </div>
                    <img
                      src={CUSTOMIZE}
                      style={{
                        marginBottom: 'auto', height: '14px', width: '14px', marginTop: '21px',
                      }}
                      alt="customize icon"
                    />
                  </div>
                </div>

                <h2 className="address_card_content_aside_subtitle">Other Providers</h2>

                <div
                  style={{ width: '100%' }}
                  draggable
                  onDragStart={e => this.dragStartHandler(e, 'AT&T')}
                  onDrag={this.dragHandler}
                  onDragEnd={this.dragEndHandler}
                >
                  <AsideStatistic percent={65} title="AT&T">
                    <div className="address_card_tag_row">
                      <ImageWithText src={isDarkTheme ? FIBER_ICON_DARK : FIBER_ICON} text="Fiber" />
                      <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
                    </div>
                    <div className="address_card_tag_row">
                      <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
                      <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
                    </div>
                  </AsideStatistic>
                </div>

                <div
                  style={{ width: '100%' }}
                  draggable
                  onDragStart={e => this.dragStartHandler(e, 'Verizon')}
                  onDrag={this.dragHandler}
                  onDragEnd={this.dragEndHandler}
                >
                  <AsideStatistic percent={65} title="Verizon">
                    <div className="address_card_tag_row">
                      <ImageWithText src={isDarkTheme ? FIBER_ICON_DARK : FIBER_ICON} text="Fiber" />
                      <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
                    </div>
                    <div className="address_card_tag_row">
                      <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
                      <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
                    </div>
                  </AsideStatistic>
                </div>

                <div
                  style={{ width: '100%' }}
                  draggable
                  onDragStart={e => this.dragStartHandler(e, 'Sprint')}
                  onDrag={this.dragHandler}
                  onDragEnd={this.dragEndHandler}
                >
                  <AsideStatistic percent={65} title="Sprint">
                    <div className="address_card_tag_row">
                      <ImageWithText src={isDarkTheme ? FIBER_ICON_DARK : FIBER_ICON} text="Fiber" />
                      <ImageWithText src={isDarkTheme ? TRUCK_ICON_DARK : TRUCK_ICON} text="Carrier" />
                    </div>
                    <div className="address_card_tag_row">
                      <ImageWithText src={isDarkTheme ? SPEED_ICON_DARK : SPEED_ICON} text="100 mbsp" />
                      <ImageWithText src={isDarkTheme ? CIRCLE_ICON_DARK : CIRCLE_ICON} text="On-Net" />
                    </div>
                  </AsideStatistic>
                </div>
              </div>
              <div className="address_card_content_aside">
                <ImageWithText src={isDarkTheme ? BARCODE_ICON_DARK : BARCODE_ICON} text="MPLSMNDT" style={{ color: '#7F8E99' }} />
                <ImageWithText src={isDarkTheme ? CUBE_ICON_DARK : CUBE_ICON} text="989-7856 " style={{ color: '#7F8E99' }} />
                <ImageWithText src={isDarkTheme ? GLOBE_ICON_DARK : GLOBE_ICON} text="37.480519 ; -122.20775" style={{ color: '#7F8E99' }} />
                <h3>Building Information</h3>
                <p className="address_card_content_aside_text">LATA: 730</p>
                <p className="address_card_content_aside_text">NPA-NXX: 989-7856</p>
                <p className="address_card_content_aside_text">OCN: 985A</p>
                <p className="address_card_content_aside_text">Zip Code +4: 76543-9999</p>
                <p className="address_card_content_aside_text">Building Type: Residential</p>
                <p className="address_card_content_aside_text">Commercial Type: H</p>
                <p className="address_card_content_aside_text">Country Name: United States</p>
                <p className="address_card_content_aside_text">TIme Zone: Pacific</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isDarkTheme: state.app.isDarkTheme,
});

const Connected = connect(mapStateToProps)(AddressCard);
export { Connected as AddressCard };



// WEBPACK FOOTER //
// ./src/view/screens/ModalBodies/AddressCard.js